// Handles add to cart button clicks
document.addEventListener('DOMContentLoaded', function () {
  // Only runs on moia-add-to-cart-button element
  if (!customElements.get('moia-add-to-cart-button')) {
    customElements.define(
      'moia-add-to-cart-button',
      class MoiaAddToCartButton extends HTMLElement {
        constructor() {
          super();
          this.loadingText = 'Adding...';
          this.handleClick = this.handleClick.bind(this);
          this.handleLoadingEvent = this.handleLoadingEvent.bind(this);
          this.addEventListener('click', this.handleClick);
          this.addEventListener('moia:add-to-cart:loading', this.handleLoadingEvent);
        }

        setLoadingState(button, isLoading) {
          if (!button) return;
          if (!button.dataset.labelDefault) {
            button.dataset.labelDefault = button.textContent.trim();
          }

          if (isLoading) {
            button.dataset.loading = 'true';
            button.setAttribute('aria-busy', 'true');
            button.setAttribute('disabled', 'disabled');
            button.classList.add('is-loading');
            button.textContent = this.loadingText;
          } else {
            button.dataset.loading = 'false';
            button.removeAttribute('aria-busy');
            button.removeAttribute('disabled');
            button.classList.remove('is-loading');
            button.textContent = button.dataset.labelDefault || button.textContent;
          }
        }

        handleLoadingEvent(event) {
          const detail = event.detail || {};
          const targetButton = detail.button;
          const isLoading = Boolean(detail.loading);
          if (targetButton && this.contains(targetButton)) {
            this.setLoadingState(targetButton, isLoading);
          }
        }

        async handleClick(event) {
          const addToCartButton = event.target.closest('.moia-card-product-add-to-cart-button');

          if (addToCartButton && addToCartButton.dataset.id) {
            if (addToCartButton.dataset.delegateFormSubmit === 'true') {
              // Let native form submit flow handle quantity/id.
              return;
            }
            event.preventDefault();
            event.stopPropagation();
            if (addToCartButton.dataset.loading === 'true') return;

            this.dispatchEvent(
              new CustomEvent('moia:add-to-cart:loading', {
                bubbles: true,
                detail: { button: addToCartButton, loading: true },
              }),
            );

            try {
              await addOrUpdateCartItem(addToCartButton.dataset.id, 1, 'moia-add-to-cart-button');
            } finally {
              this.dispatchEvent(
                new CustomEvent('moia:add-to-cart:loading', {
                  bubbles: true,
                  detail: { button: addToCartButton, loading: false },
                }),
              );
            }
          }
        }

        disconnectedCallback() {
          // Clean up event listener when component is removed
          this.removeEventListener('click', this.handleClick);
          this.removeEventListener('moia:add-to-cart:loading', this.handleLoadingEvent);
        }
      },
    );
  }
});
